import setStep from "../../../../api/deals/setStep"
import Button from "../../../../components/Button/Button"
import alert from "../../../../helpers/alert"
import extractErrorMessage from "../../../../utils/extractErrorMessage"

const StepControlButtons = ({
    dealId,
    prevStep,
    nextStep,
    update,
    setLoading,
}) => {

    const goBack = async () => {
        try {
            setLoading(true);
            await setStep({
                dealId: dealId,
                step: prevStep,
            });
            update && update();
        } catch (e) {
            alert.error(extractErrorMessage(e?.response?.data) || e?.response?.data || 'ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ Ð¿ÐµÑÐµÑÐ¾Ð´Ðµ Ð½Ð° Ð¿ÑÐµÐ´ÑÐ´ÑÑÐ¸Ð¹ ÑÐ°Ð³');
        } finally {
            setLoading(false);
        }
    }

    const goNext = async () => {
        try {
            setLoading(true);
            await setStep({
                dealId: dealId,
                step: nextStep,
            });
            update && update();
        } catch (e) {
            alert.error(extractErrorMessage(e?.response?.data) || e?.response?.data || 'ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ Ð¿ÐµÑÐµÑÐ¾Ð´Ðµ Ð½Ð° ÑÐ»ÐµÐ´ÑÑÑÐ¸Ð¹ ÑÐ°Ð³');
        } finally {
            setLoading(false);
        }
    }
    return (
        <div style={{
            display: 'flex',
            gap: 10,
            justifyContent: 'space-between',
        }}>
            {
                prevStep ? <div style={{flex: 1, display: 'flex', justifyContent: 'flex-start'}}>
                    <Button text="â" style={{fontSize: 24}} fill onClick={goBack}/>
                </div> : null
            }
            {
                nextStep ? <div style={{flex: 1, display: 'flex', justifyContent: 'flex-end'}}>
                    <Button text="â" style={{fontSize: 24}} fill onClick={goNext}/>
                </div> : null
            }
        </div>
    )
}

export default StepControlButtons;
